
// 动画-图元本身改变

import { RoamRoute } from "@/commons/interface/building/roam-route";
import { graphicStore } from "@/commons/store/graphic-store";
import { update, Tween } from "@tweenjs/tween.js";
// import { ModelBase } from "pythagoras";
import { MathUtils, Quaternion, Vector3 } from "three";

// 移动相机位置
export const roamCameraMove = (point, roamRoute) => {
    let editor = graphicStore.extraContext.getCurrentViewEditor();
    let entities = roamRoute?.entities || [];
    let pointIndex = entities.findIndex(p => p.uuid === point.uuid);
    // 切换关键点
    editor?.camera?.position?.set(point.position.x, point.position.y, point.position.z);
    if (entities.length != 0) {
        // 找到当前点在entities的位置
        let lookAtPoint;
        if (pointIndex === entities.length - 1) {
            // 当前点是最后一个点，那么就看向前一个点
            lookAtPoint = entities[pointIndex - 1];
        } else {
            // 当前点不是最后一个点，那么就看向后一个点
            lookAtPoint = entities[pointIndex + 1];
        }
        if (!!lookAtPoint) {
            const target = new Vector3(lookAtPoint.position.x, lookAtPoint.position.y, lookAtPoint.position.z);
            editor?.camera?.lookAt(target);
        }
    }
    editor.listeners.signals.needRender.dispatch();
}

/**
 * 
 * @param angleInDegrees 角度
 * @param isVertical 是否水平旋转
 */
export const roamCameraRotate = (angleInDegrees, isVertical: boolean) => {
    let editor = graphicStore.extraContext.getCurrentViewEditor();
    const camera = editor.camera;
    const angleInRadians = MathUtils.degToRad(angleInDegrees);
    let axis;

    // 判断旋转的轴
    if (!isVertical) {
        // const cameraDirection = new Vector3();
        // camera.getWorldDirection(cameraDirection);
        axis = new Vector3(1, 0, 0).applyQuaternion(camera.quaternion);
    } else {
        axis = new Vector3(0, 0, 1);  // 绕 z 轴旋转
    }

    // 创建旋转四元数
    const quaternion = new Quaternion();
    quaternion.setFromAxisAngle(axis, angleInRadians);

    // 应用旋转到相机
    camera.quaternion.premultiply(quaternion)
    // camera.rotateOnAxis(normal, angleInRadians);
    editor.listeners.signals.needRender.dispatch();
}

// 激活漫游动画
export const roamAnimate = () => {
    requestAnimationFrame(roamAnimate);
    update();
}
const RoamTime = 120000

export const createTween = (roamRoute: RoamRoute, onUpdate, onComplete, startRatio, endRatio = 1) => {
    let roamTime = roamRoute?.roamTime || RoamTime;
    const realTime = (endRatio - startRatio) * roamTime;
    const tween = new Tween({ progress: startRatio })
        .to({ progress: endRatio }, realTime)
        .dynamic(true)
        .onUpdate(onUpdate)
        .onComplete(onComplete)
    return tween;
}